import React, { useMemo, useState } from "react";
import CheckboxTree from "react-checkbox-tree";
import UniversalButton from "./UniversalButton ";

const FilterPanel = ({
  objectCategories,
  selectedCategories,
  handleCheckboxChange,
  filterBuildings,
  listsData,
  onFetchApartments,
  onFetchPolygons,
  onFetchMapObjects,
  polygonsLevels,
  polygonsListHierarchyLevels,
  thredObjListHierarchyLevels,
  threeDCategories,
}) => {
  const [selectedFilters, setSelectedFilters] = useState({
    neighborhood_name: [],
    street_name: [],
    rights: [],
    usage_type: [],
    part_type: [],
    tax: [],
    polygon_type_id: [],
    plant_type: [],
    selectedValues: [],
  });

  const [neighborhoodChecked, setNeighborhoodChecked] = useState([]);
  const [polygonTypeChecked, setPolygonTypeChecked] = useState([]);
  const [threeDChecked, setThreeDChecked] = useState([]);
  const [neighborhoodExpanded, setNeighborhoodExpanded] = useState([]);
  const [polygonTypeExpanded, setPolygonTypeExpanded] = useState([]);
  const [threeDExpanded, setThreeDExpanded] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasRight");
    if (!offcanvasElement) return;
  
    const offcanvasInstance = window.bootstrap?.Offcanvas.getInstance(offcanvasElement);
    if (!offcanvasInstance) {
      const newInstance = new window.bootstrap.Offcanvas(offcanvasElement);
      newInstance.hide();
    } else {
      offcanvasInstance.hide();
    }
  };
  

  const handleListCheckboxAsRadio = (listTypeName, listId) => {
    const fieldName =
      listTypeMapping[listTypeName] ||
      listPolygons[listTypeName] ||
      listPlantProperties[listTypeName];
    if (!fieldName) return;

    setSelectedFilters((prevFilters) => {
      const currentSelected = prevFilters[fieldName]?.[0];
      if (currentSelected === listId) {
        return { ...prevFilters, [fieldName]: [] };
      }
      return { ...prevFilters, [fieldName]: [listId] };
    });
  };

  const handleNeighborhoodCheck = (newChecked) => {
    const parentMap = {};
    const walk = (nodes) => {
      nodes.forEach((node) => {
        if (node.children) {
          node.children.forEach((child) => {
            parentMap[child.value] = node.value;
          });
          walk(node.children);
        }
      });
    };
    walk(neighborhoodNodes);

    const ancestors = newChecked.flatMap((id) => {
      const ancestorsList = [];
      let parent = parentMap[id];
      while (parent) {
        ancestorsList.push(parent);
        parent = parentMap[parent];
      }
      return ancestorsList;
    });

    setNeighborhoodChecked([...new Set([...newChecked, ...ancestors])]);
  };

  const handlePolygonTypeCheck = (newChecked) => {
    const parentMap = {};
    const walk = (nodes) => {
      nodes.forEach((node) => {
        if (node.children) {
          node.children.forEach((child) => {
            parentMap[child.value] = node.value;
          });
          walk(node.children);
        }
      });
    };
    walk(polygonTypeNodes);

    const ancestors = newChecked.flatMap((id) => {
      const ancestorsList = [];
      let parent = parentMap[id];
      while (parent) {
        ancestorsList.push(parent);
        parent = parentMap[parent];
      }
      return ancestorsList;
    });

    setPolygonTypeChecked([...new Set([...newChecked, ...ancestors])]);
  };

  const handleThreeDCheck = (newChecked) => {
    const parentMap = {};
    const walk = (nodes) => {
      nodes.forEach((node) => {
        if (node.children) {
          node.children.forEach((child) => {
            parentMap[child.value] = node.value;
          });
          walk(node.children);
        }
      });
    };
    walk(threeDNodes);

    const ancestors = newChecked.flatMap((id) => {
      const ancestorsList = [];
      let parent = parentMap[id];
      while (parent) {
        ancestorsList.push(parent);
        parent = parentMap[parent];
      }
      return ancestorsList;
    });

    const checkedWithAncestors = [...new Set([...newChecked, ...ancestors])];
    setThreeDChecked(checkedWithAncestors);

    const selectionsMap = {};

    checkedWithAncestors.forEach((value) => {
      const [type, ...args] = value.split("_");
      if (type === "child") {
        const [keyId, listId, listTypeId, threedObjectId] = args;
        if (!keyId || !listId || !listTypeId || !threedObjectId) return;
        const categoryValue = parentMap[`obj_${threedObjectId}`];
        if (!categoryValue) return;
        const categoryId = categoryValue.split("_")[1];

        if (!selectionsMap[categoryId]) {
          selectionsMap[categoryId] = { categoryId, objects: {} };
        }
        if (!selectionsMap[categoryId].objects[threedObjectId]) {
          selectionsMap[categoryId].objects[threedObjectId] = {
            threedObjectId,
            keys: [],
          };
        }
        selectionsMap[categoryId].objects[threedObjectId].keys.push({
          keyId,
          listId,
        });
      } else if (type === "key") {
        const [keyId, listTypeId, threedObjectId] = args;
        if (!keyId || !listTypeId || !threedObjectId) return;
        const categoryValue = parentMap[`obj_${threedObjectId}`];
        if (!categoryValue) return;
        const categoryId = categoryValue.split("_")[1];

        if (!selectionsMap[categoryId]) {
          selectionsMap[categoryId] = { categoryId, objects: {} };
        }
        if (!selectionsMap[categoryId].objects[threedObjectId]) {
          selectionsMap[categoryId].objects[threedObjectId] = {
            threedObjectId,
            keys: [],
          };
        }
        const hasChild = selectionsMap[categoryId].objects[
          threedObjectId
        ].keys.some((k) => k.keyId === keyId && k.listId);
        if (!hasChild) {
          selectionsMap[categoryId].objects[threedObjectId].keys.push({
            keyId,
          });
        }
      } else if (type === "obj") {
        const [threedObjectId] = args;
        if (!threedObjectId) return;
        const categoryValue = parentMap[`obj_${threedObjectId}`];
        if (!categoryValue) return;
        const categoryId = categoryValue.split("_")[1];

        if (!selectionsMap[categoryId]) {
          selectionsMap[categoryId] = { categoryId, objects: {} };
        }
        if (!selectionsMap[categoryId].objects[threedObjectId]) {
          selectionsMap[categoryId].objects[threedObjectId] = {
            threedObjectId,
            keys: [],
          };
        }
      } else if (type === "top") {
        const [categoryId] = args;
        if (!categoryId) return;
        if (!selectionsMap[categoryId]) {
          selectionsMap[categoryId] = { categoryId, objects: {} };
        }
      }
    });

    const selectedValues = {
      categories: Object.values(selectionsMap).map((category) => ({
        categoryId: category.categoryId,
        objects: Object.values(category.objects),
      })),
    };

    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      selectedValues,
    }));
    console.log(
      "Updated selectedValues:",
      JSON.stringify(selectedValues, null, 2)
    );
  };

  const handleThreeDExpand = (expanded) => {
    console.log("threeDExpanded:", expanded);
    setThreeDExpanded(expanded);
  };

  const neighborhoodNodes = useMemo(() => {
    const toNodes = (list) =>
      list.map((p) => ({
        value: p.id,
        label: p.name,
        children: p.children?.length ? toNodes(p.children) : [],
      }));
    return toNodes(polygonsLevels || []);
  }, [polygonsLevels]);

  const polygonTypeNodes = useMemo(() => {
    const toNodes = (list) =>
      list.map((p) => ({
        value: `top_${p.id}_${p.listTypeId}`,
        label: p.name,
        children: p.children?.length
          ? p.children.map((child) => ({
              value: `key_${child.polygonKeyId}_${child.listTypeId}_${child.polygonTypeId}`,
              label: child.name,
              children: child.children
                .filter((grandChild) => grandChild.id != null)
                .map((grandChild) => ({
                  value: `child_${child.polygonKeyId}_${grandChild.id}_${grandChild.listTypeId}_${p.id}`,
                  label: grandChild.name,
                })),
            }))
          : [],
      }));
    return toNodes(polygonsListHierarchyLevels || []);
  }, [polygonsListHierarchyLevels]);

  const threeDNodes = useMemo(() => {
    const toNodes = (list) =>
      list.map((p) => {
        if (!p.id || !p.name) {
          console.warn("Invalid category entry:", p);
          return null;
        }
        return {
          value: `top_${p.id}`,
          label: p.name,
          children:
            p.children
              ?.map((child) => {
                if (!child.id || !child.name) {
                  console.warn("Invalid object child:", child);
                  return null;
                }
                return {
                  value: `obj_${child.id}`,
                  label: child.name,
                  children: child.children
                    .filter(
                      (key) =>
                        key.threedKeyId != null &&
                        key.listTypeId != null &&
                        key.name != null
                    )
                    .map((key) => ({
                      value: `key_${key.threedKeyId}_${key.listTypeId}_${child.id}`,
                      label: key.name,
                      children: key.children
                        .filter(
                          (grandChild) =>
                            grandChild.id != null && grandChild.name != null
                        )
                        .map((grandChild) => ({
                          value: `child_${key.threedKeyId}_${grandChild.id}_${key.listTypeId}_${child.id}`,
                          label: grandChild.name,
                        })),
                    })),
                };
              })
              ?.filter(Boolean) || [],
        };
      });

    const nodes = toNodes(thredObjListHierarchyLevels || []).filter(Boolean);
    console.log("threeDNodes:", JSON.stringify(nodes, null, 2));
    return nodes;
  }, [thredObjListHierarchyLevels]);

  const listTypeMapping = {
    "Të drejtat": "rights",
    "Natyra e shfrytëzimit": "usage_type",
    "Lloji i pjesës së ndërtesës": "part_type",
    "Tatimi në pronë": "tax",
  };

  const listPlantProperties = {
    "Lloji i bimësisë": "plant_type",
  };

  const listPolygons = {
    "Lloji i poligonit": "polygon_type_id",
  };

  const handleListSelection = (listTypeName, listId) => {
    const fieldName =
      listTypeMapping[listTypeName] ||
      listPolygons[listTypeName] ||
      listPlantProperties[listTypeName];
    if (!fieldName) return;

    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };
      if (updatedFilters[fieldName]?.includes(listId)) {
        updatedFilters[fieldName] = updatedFilters[fieldName].filter(
          (id) => id !== listId
        );
      } else {
        updatedFilters[fieldName] = [
          ...(updatedFilters[fieldName] || []),
          listId,
        ];
      }
      return updatedFilters;
    });
  };

  const handleListRadioSelection = (listTypeName, listId) => {
    const fieldName =
      listTypeMapping[listTypeName] ||
      listPolygons[listTypeName] ||
      listPlantProperties[listTypeName];
    if (!fieldName) return;

    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };
      updatedFilters[fieldName] = [listId];
      return updatedFilters;
    });
  };

  const fetchFilteredApartments = async () => {
    try {
      setIsLoading(true);
      const filteredRequest = getFilteredRequest();
      await onFetchApartments(filteredRequest);
    } catch (error) {
      console.error("Error filtering apartments:", error);
    } finally {
      setIsLoading(false);
      closeOffcanvas();
    }
  };

  const fetchFilteredPolygons = async () => {
    try {
      setIsLoading(true);
      const payload = {};

      if (neighborhoodChecked.length > 0) {
        payload.polygon_id = neighborhoodChecked;
      }

      if (polygonTypeChecked.length > 0) {
        const polygonTypeSelections = {
          topLevel: [],
          keys: [],
          children: [],
        };

        const uniqueTopLevelIds = new Set();

        polygonTypeChecked.forEach((value) => {
          const [type, ...rest] = value.split("_");
          if (type === "top") {
            const [, id, listTypeId] = rest;
            const topLevelId = rest[0];
            if (!uniqueTopLevelIds.has(topLevelId) && topLevelId) {
              polygonTypeSelections.topLevel.push({
                id: topLevelId,
                listTypeId: parseInt(listTypeId) || 12,
              });
              uniqueTopLevelIds.add(topLevelId);
            }
          } else if (type === "key") {
            const [polygonKeyId, listTypeId, polygonTypeId] = rest;
            polygonTypeSelections.keys.push({
              polygonKeyId,
              listTypeId: parseInt(listTypeId),
              polygonTypeId: parseInt(polygonTypeId),
            });
          } else if (type === "child") {
            const [parentKeyId, id, listTypeId, polygonTypeId] = rest;
            if (id && id !== "null") {
              polygonTypeSelections.children.push({
                id: parseInt(id),
                listTypeId: parseInt(listTypeId),
                polygonTypeId: parseInt(polygonTypeId),
              });
            }
          }
        });

        polygonTypeSelections.children = Array.from(
          new Map(
            polygonTypeSelections.children.map((child) => [
              `${child.id}_${child.listTypeId}`,
              child,
            ])
          ).values()
        );

        payload.polygon_type = polygonTypeSelections;
        payload.polygon_type_id = Array.from(uniqueTopLevelIds);
      }

      console.log("Polygon Payload:", JSON.stringify(payload, null, 2));
      await onFetchPolygons(payload);
    } catch (error) {
      console.error("Error filtering polygons:", error);
    } finally {
      setIsLoading(false);
      closeOffcanvas();
    }
  };

  const fetchFilteredMapObjects = async () => {
    try {
      setIsLoading(true);
      const payload = {
        selectedValues: selectedFilters.selectedValues,
      };

      if (selectedFilters.selectedValues.length === 0) {
        console.warn("No 3D object filters selected. Fetching all...");
        await onFetchMapObjects({});
      } else {
        console.log("3D Objects Payload:", JSON.stringify(payload, null, 2));
        await onFetchMapObjects(payload);
      }
    } catch (error) {
      console.error("Error filtering 3D objects:", error);
    } finally {
      setIsLoading(false);
      closeOffcanvas();
    }
  };

  const getFilteredRequest = () => {
    return Object.fromEntries(
      Object.entries(selectedFilters).filter(
        ([key, value]) => key !== "selectedValues" && value.length > 0
      )
    );
  };

  return (
    <div
      style={{ position: "absolute", bottom: "5%", left: "0.5%", zIndex: 95 }}
    >
      <button
        className="btn btn-secondary rounded-pill shadow"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
      >
        <i className="fa fa-filter"></i>
      </button>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header bg-dark text-white">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            Filtrimet e hartës 3D
          </h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body px-4 py-3">
          <ul className="nav nav-pills nav-justified mb-3">
            <li className="nav-item">
              <button
                className="nav-link active"
                id="apartments-tab"
                data-bs-toggle="tab"
                data-bs-target="#apartments"
                type="button"
              >
                🏠 Apartamentet
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link"
                id="polygons-tab"
                data-bs-toggle="tab"
                data-bs-target="#polygons"
                type="button"
              >
                📐 Poligonet
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link"
                id="objects3d-tab"
                data-bs-toggle="tab"
                data-bs-target="#objects3d"
                type="button"
              >
                🧊 3D Objektet
              </button>
            </li>
          </ul>

          <div className="tab-content text-start">
            <div className="tab-pane fade show active" id="apartments">
              {listsData?.length > 0 ? (
                listsData.map((listType) => {
                  const mappedField = listTypeMapping[listType.name];
                  if (!mappedField) return null;

                  return (
                    <div key={listType.id} className="mb-3">
                      <h6 className="fw-bold">{listType.name}</h6>
                      {listType.lists.length > 0 ? (
                        listType.lists.map((list) => (
                          <div className="form-check" key={list.id}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`list-${list.id}`}
                              checked={
                                selectedFilters[mappedField]?.[0] === list.id
                              }
                              onChange={() =>
                                handleListCheckboxAsRadio(
                                  listType.name,
                                  list.id
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`list-${list.id}`}
                            >
                              {list.name}
                            </label>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted">Asnjë listë nuk u gjet</div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div>Nuk ka lista në dispozicion</div>
              )}

              <UniversalButton onClick={fetchFilteredApartments} disabled={isLoading}>
                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  "Filtro apartamentet"
                )}
              </UniversalButton>
            </div>

            <div className="tab-pane fade" id="polygons">
              <div className="mb-3">
                <h6 className="fw-bold">Lagjet</h6>
                <CheckboxTree
                  nodes={neighborhoodNodes}
                  checked={neighborhoodChecked}
                  expanded={neighborhoodExpanded}
                  onCheck={handleNeighborhoodCheck}
                  onExpand={setNeighborhoodExpanded}
                  showNodeIcon={false}
                  noCascade
                  iconsClass="fa4"
                />
              </div>
              <div className="mb-3">
                <h6 className="fw-bold">Llojet e poligoneve</h6>
                <CheckboxTree
                  nodes={polygonTypeNodes}
                  checked={polygonTypeChecked}
                  expanded={polygonTypeExpanded}
                  onCheck={handlePolygonTypeCheck}
                  onExpand={setPolygonTypeExpanded}
                  showNodeIcon={false}
                  noCascade
                  iconsClass="fa4"
                />
              </div>

              <UniversalButton onClick={fetchFilteredPolygons} disabled={isLoading}>
                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  "Filtro poligonet"
                )}
              </UniversalButton>
            </div>

            <div className="tab-pane fade" id="objects3d">
              <div className="mb-3">
                <h6 className="fw-bold">Kategoritë e objekteve 3D</h6>
                {threeDNodes.length > 0 ? (
                  <CheckboxTree
                    nodes={threeDNodes}
                    checked={threeDChecked}
                    expanded={threeDExpanded}
                    onCheck={handleThreeDCheck}
                    onExpand={handleThreeDExpand}
                    showNodeIcon={false}
                    noCascade
                    iconsClass="fa4"
                  />
                ) : (
                  <div className="text-muted">
                    Nuk ka objekte 3D në dispozicion.
                  </div>
                )}
              </div>
              <UniversalButton onClick={fetchFilteredMapObjects} disabled={isLoading}>
                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  "Filtro 3D objektet"
                )}
              </UniversalButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;